import script from "./baseline-terminal-top-ranking.vue?vue&type=script&setup=true&lang=ts"
export * from "./baseline-terminal-top-ranking.vue?vue&type=script&setup=true&lang=ts"

import "./baseline-terminal-top-ranking.vue?vue&type=style&index=0&id=2c0d0a71&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0d0a71"]])

export default __exports__